// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rLzh3","content":"styles_content__KXwDi"};